"use client";

import type { MutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import gql from "graphql-tag";
import type {
  CanvasSchedulerResponse,
  RescheduleCanvasPhoneAppointmentInput,
} from "@rmh/defs";
import type { GeneratedMutation } from "@aws-amplify/api-graphql";
import { fetchGraphQLClient } from "../../../amplify/fetchGraphQLClient";

interface RescheduleCanvasPhoneAppointmentVariables {
  input: RescheduleCanvasPhoneAppointmentInput;
}

interface RescheduleCanvasPhoneAppointmentResponse {
  data?: {
    rescheduleCanvasPhoneAppointment: CanvasSchedulerResponse;
  };
}

export const rescheduleCanvasPhoneAppointmentMutation = gql`
  mutation rescheduleCanvasPhoneAppointment(
    $input: RescheduleCanvasPhoneAppointmentInput!
  ) {
    rescheduleCanvasPhoneAppointment(input: $input) {
      success
      error {
        type
        message
        details
      }
      data {
        appointmentId
        canvasAppointmentId
        canvasPractitionerId
        appointmentDateTime
        timestamp
      }
    }
  }
`.loc?.source.body as GeneratedMutation<
  RescheduleCanvasPhoneAppointmentVariables,
  {
    rescheduleCanvasPhoneAppointment: CanvasSchedulerResponse;
  }
>;

export const useRescheduleCanvasPhoneAppointment = (
  options: MutationOptions<
    RescheduleCanvasPhoneAppointmentResponse,
    Error,
    RescheduleCanvasPhoneAppointmentVariables
  > = {}
) => {
  const { mutateAsync, isPending } = useMutation<
    RescheduleCanvasPhoneAppointmentResponse,
    Error,
    RescheduleCanvasPhoneAppointmentVariables
  >({
    ...options,
    mutationFn: async (variables) =>
      fetchGraphQLClient(rescheduleCanvasPhoneAppointmentMutation, variables),
  });

  const rescheduleCanvasPhoneAppointment = async (
    input: RescheduleCanvasPhoneAppointmentInput
  ) => {
    try {
      const response = await mutateAsync({ input });

      return response?.data?.rescheduleCanvasPhoneAppointment;
    } catch (error) {
      console.error("Failed to reschedule Canvas phone appointment", error);
      throw error;
    }
  };

  return {
    rescheduleCanvasPhoneAppointment,
    isPending,
  };
};
